export const getFilenameExtension = (filename: string): string =>
  filename.substring(filename.lastIndexOf('.') + 1, filename.length) || filename
